import { render, staticRenderFns } from "./SpeechBalloonLoader.vue?vue&type=template&id=2281381e&scoped=true&"
import script from "./SpeechBalloonLoader.vue?vue&type=script&lang=js&"
export * from "./SpeechBalloonLoader.vue?vue&type=script&lang=js&"
import style0 from "./SpeechBalloonLoader.vue?vue&type=style&index=0&id=2281381e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2281381e",
  null
  
)

export default component.exports